export default "__VITE_ASSET__DO7UZw7H__"